import dayjs from 'dayjs'

dayjs.locale('en')

export const DISPLAY_DATE_FORMAT = 'DD-MMM-YYYY'
export const DISPLAY_DATE_TIME_FORMAT = `${DISPLAY_DATE_FORMAT} HH:mm`

export function formatDate(d: string | Date | null | undefined, fmt = DISPLAY_DATE_FORMAT): string {
  if (!d) return ''
  const m = dayjs(d)
  return m.isValid() ? m.locale('en').format(fmt) : ''
}

export function formatDateTime(d: string | Date | null | undefined): string {
  return formatDate(d, DISPLAY_DATE_TIME_FORMAT)
}

export function toIsoDate(d: dayjs.Dayjs | Date | null | undefined): string | null {
  if (!d) return null
  const m = dayjs(d)
  return m.isValid() ? m.format('YYYY-MM-DD') : null
}
